
export const sendSurveyData = (user, surveyData, changeData, started, lang) => {

        const serverAddress = "https://evaluation-gh-default-rtdb.europe-west1.firebasedatabase.app/";
    
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
    
        const raw = JSON.stringify({
            "userId": user,
            "data": surveyData,
            "changeData": changeData,
            "lang": lang,
            "times": {
                started: started,
                finished: Date.now()
            }
        });
    
        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
    
        return fetch(serverAddress + "evaluation.json", requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error));
}

export const sendMailInfo = (user, mail) => {

    const serverAddress = "https://evaluation-gh-default-rtdb.europe-west1.firebasedatabase.app/";

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
        "userId": user,
        "mail": mail,
        "time": Date.now()
    });

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    return fetch(serverAddress + "mails.json", requestOptions)
    .then(response => response.json())
    .catch(error => console.log('error', error));
}